<template>
  <div class="wrapper">
    <side-bar>
      <template slot="control">
        <sidebar-link class="sidebar-control reduce-menu" :link="{name: $t('reduce_menu'), icon:'fas fa-circle', path:'reduceSidebar'}"/>
        <sidebar-link class="sidebar-control extend-menu" :link="{name: $t('extend_menu'), icon:'', path:'extendSidebar'}"/>
        <!--<sidebar-link class="sidebar-control close-menu" :link="{name: $t('close_menu'), icon:'fas fa-times', path:'closeSidebar'}"/>-->
        <sidebar-link class="sidebar-control open-menu" :link="{name: $t('open_menu'), icon:'', path:'openSidebar'}"/>
      </template>
      <div v-if="user.rol_id == 1">
        <sidebar-item :link="{name: $t('inicio'), icon:'icon-svg icon-home', path:'/admin', exact: true}"/>
        <!-- <sidebar-item :link="{name: $t('Concursal'), icon:'fas fa-money-check', path:'/admin/ranking_ac'}">
            <sidebar-item :link="{name: $t('Ranking_AC'), icon:'fas fa-chart-bar',  path: '/admin/ranking_ac'}"></sidebar-item>
            <sidebar-item :link="{name: $t('Administradores'), icon: 'fas fa-users',  path: '/admin/admin_concursal'}"></sidebar-item>
                <sidebar-item :link="{name: $t('concursos'), icon: 'fas fa-hands-helping', path: '/admin/concursos'}"></sidebar-item>
        </sidebar-item> -->
        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('GestorDocumental')}}</span>
          <span class="sidebar-group-title__abbr">GD</span>
        </p>
        <sidebar-item :link="{name: $t('Documentos'), icon:'icon-svg icon-file-text', path:'/admin/documents'}"/>
        <sidebar-item :link="{name: $t('solicitudes_pendientes'), icon:'icon-svg icon-clock', path:'/admin/solicitudes_pdte'}"/>

        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('Companias')}}</span>
          <span class="sidebar-group-title__abbr">COMP</span>
        </p>
        <sidebar-item :link="{name: $t('listado_companias'), icon:'icon-svg icon-building', path:'/admin/contacts'}"/>
        <sidebar-item :link="{name: $t('Usuarios'), icon:'icon-svg icon-user', path:'/admin/users'}"/>

        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('agenda')}}</span>
          <span class="sidebar-group-title__abbr">AG</span>
        </p>
        <sidebar-item :link="{name: $t('mi_calendario'), icon:'icon-svg icon-calendar', path:'/admin/agenda'}"/>

        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('config')}}</span>
          <span class="sidebar-group-title__abbr">CONF</span>
        </p>
        <sidebar-item :link="{name: $t('plantillas_solicitud'), icon:'icon-svg icon-clipboard-list', path:'/admin/solicitud_doc'}"/>
        <sidebar-item :link="{name: $t('Etiquetas'), icon:'icon-svg icon-tag', path:'/admin/tags'}"/>
      </div>
      <div v-if="user.rol_id == 2">
        <sidebar-item :link="{name: $t('inicio'), icon:'icon-svg icon-home', path:'/admin', exact: true}"/>
        <!-- <sidebar-item :link="{name: $t('Cliente'), icon:'fas fa-user'}">
          <sidebar-item :link="{name: $t('DatosCliente'), icon:'fas fa-id-card', path:'/admin/ficha_cliente'}"/>
        </sidebar-item> -->
        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('GestorDocumental')}}</span>
          <span class="sidebar-group-title__abbr">GD</span>
        </p>
        <sidebar-item :link="{name: $t('folders'), icon:'icon-svg icon-folder', path:'/admin/carpetas'}"/>
        <sidebar-item :link="{name: $t('Documentos'), icon:'icon-svg icon-file-text', path:'/admin/documentos'}"/>

        <p class="sidebar-group-title">
          <span class="sidebar-group-title__full">{{$t('agenda')}}</span>
          <span class="sidebar-group-title__abbr">AG</span>
        </p>
        <sidebar-item :link="{name: 'Agenda', icon:'icon-svg icon-calendar', path:'/admin/agenda'}"/>
      </div>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <!-- Oculto en pantalla, visible solo al imprimir (ver
           variations.scss): sustituye al sidebar/navbar, que ahí se
           ocultan del todo, para que el papel siga llevando la marca. -->
      <div class="print-header">
        <img src="@/assets/images/logo_cleverdocs.png" alt="CleverDocs" />
      </div>

      <dashboard-content @click="toggleSidebar"></dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import { mapGetters } from 'vuex';
  import TopNavbar from './TopNavbar.vue'
  // import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  export default {
    computed: {
        ...mapGetters({
            user: 'login/user'
        })
    },
    components: {
      TopNavbar,
      // ContentFooter,
      DashboardContent
    },
    methods: {
      toggleSidebar ()
      {
        this.$sidebar.toggleSidebar = !this.$sidebar.toggleSidebar;
      }
    }
  }
</script>
